import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function MoveLeftIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M19.25 4.75V19.25M4.75 12H15.25M4.75 12L8.25 8.75M4.75 12L8.25 15.25"
        stroke="#384150"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
